import { LoadingSpinnerIcon, Typography } from '@mgmresorts/wcl-lab';
import { styled, media, $black } from '@mgmresorts/wcl-styled';
import React from 'react';

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 80px 0;
  text-align: center;
  position: relative;
`;

const StyledIcon = styled.div`
  font-size: 64px;
  color: ${p => p.theme.colors.interface};
  margin-bottom: 32px;
`;

const StyledTitle = styled(Typography)`
  color: ${$black};
  font-size: 26px;
  font-weight: 500;
  line-height: 35px;
  margin: 20px 0;

  ${media.minMd`
    font-size: 45px;
    margin-bottom: 56px;
  `}
`;

interface LoaderProps {
  icon?: React.ReactNode;
  title?: string;
}

export const Loader = ({ icon, title }: LoaderProps) => {
  const loaderIcon = icon ?? <LoadingSpinnerIcon testId='spinner' m='0.5rem' size={44} strokeWidth={4} />;

  return (
    <StyledWrapper data-testid='Loader'>
      <div>
        {title && <StyledTitle testId='loader-title'>{title}</StyledTitle>}
        {loaderIcon && <StyledIcon data-testid='loader-icon'>{loaderIcon}</StyledIcon>}
      </div>
    </StyledWrapper>
  );
};

Loader.displayName = 'Loader';
